// 🔄 신청서 전체 상태 정의 (업데이트됨)
export const APPLICATION_STATUS_LIST = [
  '전체',
  '접수완료', // 사용자가 신청서를 제출한 초기 상태
  '택배접수', // 방문택배 회수 요청이 완료된 상태
  '입고완료', // 기기가 물리적으로 회사에 도착한 상태
  '검수중',   // 하나 이상의 기기가 검수 진행 중일 때
  '가격안내', // 모든 기기에 대해 가격 제안이 완료된 상태
  '입금대기', // 모든 기기가 '수락됨'일 때
  '부분완료', // 일부 기기만 수락되고 나머지는 반송된 경우
  '반송', // 모든 기기가 반송 요청된 경우
  '완료',     // 입금까지 완료된 상태
] as const;

// 🔄 개별 기기 상태 정의 (사용자 요구사항에 맞는 8개 상태)
export const DEVICE_STATUS_LIST = [
  '접수완료', // 기기 접수 완료 (신청서와 동기화)
  '택배접수', // 택배 접수 완료 (신청서와 동기화)  
  '입고완료', // 기기 입고 완료 (신청서와 동기화)
  '검수중',   // 기기 검수 진행 중
  '가격안내', // 가격 제안 완료
  '입금대기', // 사용자가 해당 기기의 제안 가격에 동의
  '반송',     // 사용자가 해당 기기를 반송 요청
  '완료',     // 수락된 기기에 대해 입금까지 완료된 상태
] as const;

// 🔄 하위 호환성을 위한 기존 export (deprecated)
/** @deprecated APPLICATION_STATUS_LIST를 사용하세요 */
export const STATUS_LIST = APPLICATION_STATUS_LIST;

// 타입 정의
export type ApplicationStatus = typeof APPLICATION_STATUS_LIST[number];
export type DeviceStatus = typeof DEVICE_STATUS_LIST[number];